<template>
<div class="page-information">
  <h4>个人信息</h4>
  <div class="line"></div>
  <el-form ref="form" :model="userForm" label-width="75px" style="width:400px;padding:15px 0;">
    <input type="password" class="hideform" id="loginPassword" />
    <input type="text" class="hideform" id="loginUserName" />
    <el-form-item label="姓名">
      <el-input v-model="userForm.name"></el-input>
    </el-form-item>
    <el-form-item label="昵称">
      <el-input v-model="userForm.nickName"></el-input>
    </el-form-item>
    <el-form-item label="生日">
      <el-date-picker type="date" placeholder="选择日期" v-model="userForm.birthday" style="width: 100%;"></el-date-picker>
    </el-form-item>
    <el-form-item label="性别">
      <el-radio-group v-model="userForm.gender">
        <el-radio :label="1">男</el-radio>
        <el-radio :label="0">女</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" style="width:100px;" @click="Submit">修 改</el-button>
    </el-form-item>
  </el-form>
</div>
</template>

<script>
import User from '@/api/user';

export default {
  name: 'information',
  inject: ['reload'],
  data() {
    return {
      userid: window.localStorage.USERID,
      userForm: {
        id: '',
        logoUrl: '',
        name: '',
        nickName: '',
        birthday: '',
        gender: -1
      }
    }
  },
  async created() {
    if (this.userid) {
      let response = await User.GetUserInfo({
        id: this.userid
      });
      if (response.resCode === 0) {
        if (response.id !== undefined) this.userForm.id = response.id;
        if (response.logoUrl !== undefined) this.userForm.logoUrl = response.logoUrl;
        if (response.name !== undefined) this.userForm.name = response.name;
        if (response.nickName !== undefined) this.userForm.nickName = response.nickName;
        if (response.birthday !== undefined) this.userForm.birthday = response.birthday;
        if (response.gender !== undefined) this.userForm.gender = response.gender;
        this.$store.commit('setUserinfo', response);
      }
    }
  },
  methods: {
    openSuccess(text) {
      this.$message({
        showClose: true,
        message: text,
        type: 'success'
      });
    },
    openError(text) {
      this.$message({
        showClose: true,
        message: text,
        type: 'error'
      });
    },
    async Submit() {
      let param = {
        "id": this.userForm.id,
        "name": this.userForm.name,
        "nickName": this.userForm.nickName,
        "birthday": Number(this.userForm.birthday),
        "gender": this.userForm.gender
      }

      let response = await User.UpdateUserInfo(param);
      if (response.resCode === 0) {
        this.reload();
      } else {
        this.openError(this.$store.state.message.errorSubmit);
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>
